export const CLONE_GARMENT_SELECTION_TEST_IDS = {
  CONTAINER: 'cloneGarmentSelection-container',
  TITLE: 'cloneGarmentSelection-title',
  DESCRIPTION: 'cloneGarmentSelection-description',
  CLOSE_BTN: 'cloneGarmentSelection-close',
  CONTINUE_BTN: 'cloneGarmentSelection-continue',
  ERROR: 'cloneGarmentSelection-error',
  getGarmentRow: (id: number | string) => `cloneGarmentSelection-row-${id}`,
} as const;
